import {
  CONTENT_MARGIN, MAX_MODAL_WIDTH,
  MODAL_VIEWPORT_PERCENTAGE,
  OVERLAY_DESKTOP_TABLET_PADDING,
  OVERLAY_MOBILE_PADDING
} from '../Modal/ModalUtil';

const ASPECT_RATIO = (16 / 9);

export const getPlayerWidth = (viewportWidth: number, isMobile?: boolean, isTablet?: boolean) => {
  let playerWidth: number;

  if (viewportWidth >= 500 && viewportWidth < 700) {
    playerWidth = viewportWidth - OVERLAY_MOBILE_PADDING - CONTENT_MARGIN;
  }
  else if (isMobile) {
    playerWidth = viewportWidth - OVERLAY_MOBILE_PADDING;
  }
  else if (isTablet) {
    playerWidth = viewportWidth - OVERLAY_DESKTOP_TABLET_PADDING - CONTENT_MARGIN;
  }
  else {
    playerWidth = viewportWidth * MODAL_VIEWPORT_PERCENTAGE - CONTENT_MARGIN;
  }

  if (playerWidth > MAX_MODAL_WIDTH) {
    playerWidth = MAX_MODAL_WIDTH;
  }

  return playerWidth;
};

export const getPlayerHeight = (width: number) => width / ASPECT_RATIO;
